import { CmsObjectWithDefault } from '@components/Cms/types';

export type ChangePasswordPanelCmsKey = 'ChangePasswordTitle';

export const ChangePasswordPanelCmsWithDefault: CmsObjectWithDefault<ChangePasswordPanelCmsKey> = {
    ChangePasswordTitle: {
        cmsId: 67074,
        defaultTranslation: 'Change Password',
    },
};
